export function safeReturn(value) {
  if (typeof value !== 'string' || !/^\/assistant(?:\?|$)/.test(value) || /[\r\n\\]/.test(value)) return '/';
  return value;
}
